import ClassicControls from './ClassicControls';
import { useConfig } from '../../ConfigContext';
import { computeOverlay } from '../../../utils/overlayMath';
import LayoutGenerator from './MultipleLayouts/LayoutGenerator';
import { fontFamilies } from '../../../glassConsts';

const MultipleImagesComponent = () => {
  const { general, multipleTextConfig } = useConfig();

  return (
    <>
      {general.orientationHorizontal && (
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            pointerEvents: 'auto',
          }}
        >
          <LayoutGenerator />
          {multipleTextConfig.useText && (
            <div
              className="mobile_secondary"
              style={{
                fontFamily: fontFamilies[general.font],
                fontSize: general.size === 'S' ? 26 : 30,
                fontWeight: 'bold',
                color: general.color,
                textAlign: 'center',
                textShadow: '0 2px 8px rgba(0,0,0,0.15)',
                lineHeight: '30px',
                padding: 12,
                wordBreak: 'break-word',
              }}
            >
              {multipleTextConfig.text.length < 1
                ? 'Text'
                : multipleTextConfig.text}
            </div>
          )}
        </div>
      )}

      {!general.orientationHorizontal && (
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            pointerEvents: 'auto',
          }}
        >
          <LayoutGenerator />
          {multipleTextConfig.useText && (
            <div
              style={{
                fontFamily: fontFamilies[general.font],
                fontSize: general.size === 'S' ? 26 : 30,
                fontWeight: 'bold',
                color: general.color,
                textAlign: 'center',
                textShadow: '0 2px 8px rgba(0,0,0,0.15)',
                lineHeight: '28px',
                marginTop: 20,
                wordBreak: 'break-word',
              }}
            >
              {multipleTextConfig.text.length < 1
                ? 'Text'
                : multipleTextConfig.text}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default MultipleImagesComponent;
